/* eslint-disable react/display-name */
import LoginController from './login/loginController'

export default LoginController
